export const fromUTCToLocalTimeZone = (date) => {
    const toDate = new Date(date);
    toDate.setTime(toDate.getTime() + toDate.getTimezoneOffset() * -60000);
    return toDate;
};
export const isSameYearAsCurrent = (date) => {
    return (date === null || date === void 0 ? void 0 : date.getFullYear()) === new Date().getFullYear();
};
